import Vue from 'vue';
import Router from 'vue-router';

import { state } from '@/resources';

import { Area, AreaList, Base, Spot } from '@/views';

Vue.use(Router);

const exposedPaths = ['/areas', '/area', '/spot'];
const router = new Router({
  routes: [
    {
      path: '/',
      component: Base,
      children: [
        {
          path: '/areas',
          name: 'AreaList',
          component: AreaList
        },
        {
          path: '/area',
          name: 'Area',
          component: Area
        },
        {
          path: '/spot',
          name: 'Spot',
          component: Spot
        }
      ]
    }
  ]
});

router.beforeEach((to, from, next) => {
  if (exposedPaths.indexOf(to.path) === -1) {
    let auth = state.getState('auth');

    if (!auth) {
      next('/areas');
    }
  }

  next();
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js